import { _getItemId, _tsToDateTime } from '../../utils';

export default function ItemMetadata({ item, subitem, subId }) {
  return (
    <div style={{ marginTop: 16 }}>
      <br />
      {subitem && <div style={styles.id}>{subitem.id}</div>}
      {subId && <div style={styles.id}>{subId}</div>}
      <div style={styles.id}>{_getItemId(item)}</div>
      <div style={styles.id}>Last updated {_tsToDateTime(item._ts)}</div>
    </div>
  );
}

const styles = {
  id: { fontSize: 'x-small', color: 'grey', textAlign: 'right' }
};
